/* VIYAN hero slideshow: cross-fades the background slides of the
   viyan-hero section while the text stays fixed. Image slides advance
   after `data-slide-duration` seconds; video slides advance when the
   video ends (with a timer fallback if the video cannot play).
   Auto-rotation pauses when the tab is hidden or the hero is off
   screen, and is disabled entirely under prefers-reduced-motion. */
(function () {
  'use strict';

  function initHero(root) {
    if (root.dataset.viyanHeroInit === '1') return;
    root.dataset.viyanHeroInit = '1';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-viyan-hero-slide]')
    );
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-viyan-hero-dot]')
    );
    var duration = (parseInt(root.dataset.slideDuration, 10) || 5) * 1000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var current = 0;
    var timer = null;
    var pageVisible = !document.hidden;
    var onScreen = true;

    function slideVideo(slide) {
      return slide.querySelector('video');
    }

    function isVisible() {
      return pageVisible && onScreen;
    }

    function clearTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function playVideo(video) {
      if (!video) return;
      try {
        video.currentTime = 0;
      } catch (e) {
        /* metadata not loaded yet — play from wherever it is */
      }
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    function schedule() {
      clearTimer();
      if (reduceMotion || !isVisible()) return;
      var video = slideVideo(slides[current]);
      if (video && !video.paused && !video.ended) return; /* 'ended' advances */
      timer = setTimeout(function () {
        var v = slideVideo(slides[current]);
        if (v && !v.paused && !v.ended) {
          /* video started late — hand control back to its 'ended' event */
          schedule();
          return;
        }
        next();
      }, duration);
    }

    function activate(index) {
      clearTimer();
      var previous = slideVideo(slides[current]);
      if (previous) previous.pause();

      current = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });

      var video = slideVideo(slides[current]);
      if (video && isVisible()) playVideo(video);
      schedule();
    }

    function next() {
      activate(current + 1);
    }

    slides.forEach(function (slide) {
      var video = slideVideo(slide);
      if (!video) return;
      video.addEventListener('ended', function () {
        if (slideVideo(slides[current]) !== video) return;
        if (reduceMotion || !isVisible()) return;
        next();
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        activate(i);
      });
    });

    var startX = 0, startY = 0, tracking = false;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      activate(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    function visibilityChanged() {
      var video = slideVideo(slides[current]);
      if (!isVisible()) {
        clearTimer();
        if (video) video.pause();
        return;
      }
      if (video) {
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      }
      schedule();
    }

    document.addEventListener('visibilitychange', function () {
      pageVisible = !document.hidden;
      visibilityChanged();
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          onScreen = entries[0].isIntersecting;
          visibilityChanged();
        },
        { threshold: 0.2 }
      );
      observer.observe(root);
    }

    /* theme editor: selecting a slide block brings that slide into view */
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target;
      var index = slides.indexOf(slide);
      if (index !== -1) activate(index);
    });

    schedule();
  }

  function initAll() {
    document.querySelectorAll('[data-viyan-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
